import React from 'react';
import cn from 'classnames';
import cls from './BodyLoader.module.css';
import { Flex, Skeleton } from '@shared/ui';

interface BodyLoaderProps {
    classes?: string;
}

export const BodyLoader = ({ classes }: BodyLoaderProps) => {
    return (
        <Flex fullWidth gap={16} direction={'column'} className={cn(cls.BodyLoader, [classes])}>
            <Flex fullWidth direction={'row'} gap={32}>
                <Skeleton border={'6px'} width={'100%'} height={28} />
                <Skeleton border={'6px'} width={132} height={28} />
            </Flex>
            <Flex fullWidth direction={'column'} className={cls.loaderTable}>
                <div className={cn(cls.tableHeader, cls.row)}>
                    <div />
                    <Skeleton border={'6px'} width={'100%'} height={16} />
                    <Skeleton border={'6px'} width={'100%'} height={16} />
                    <Skeleton border={'6px'} width={'100%'} height={16} />
                    <Skeleton border={'6px'} width={'100%'} height={16} />
                    <Skeleton border={'6px'} width={'100%'} height={16} />
                </div>
                <div className={cn(cls.title, cls.stage)}>
                    <Skeleton border={'6px'} width={154} height={16} />
                </div>
                <div className={cls.row}>
                    <Skeleton border={'3px'} width={16} height={16} />
                    <Flex fullWidth direction={'column'} gap={4} align={'start'}>
                        <Skeleton border={'6px'} width={267} height={16} />
                        <Skeleton border={'6px'} width={267} height={12} />
                    </Flex>
                    <Skeleton border={'6px'} width={141} height={16} />
                    <Skeleton border={'6px'} width={95} height={16} />
                    <Skeleton border={'6px'} width={101} height={16} />
                    <Skeleton border={'6px'} width={107} height={16} />
                </div>
                <div className={cn(cls.title, cls.stage)}>
                    <Skeleton border={'6px'} width={154} height={16} />
                </div>
                <div className={cn(cls.title, cls.group)}>
                    <Skeleton border={'6px'} width={154} height={16} />
                </div>
                <div className={cls.row}>
                    <Skeleton border={'3px'} width={16} height={16} />
                    <Flex fullWidth direction={'column'} gap={4} align={'start'}>
                        <Skeleton border={'6px'} width={267} height={16} />
                        <Skeleton border={'6px'} width={267} height={12} />
                    </Flex>
                    <Skeleton border={'6px'} width={141} height={16} />
                    <Skeleton border={'6px'} width={95} height={16} />
                    <Skeleton border={'6px'} width={101} height={16} />
                    <Skeleton border={'6px'} width={107} height={16} />
                </div>
                <div className={cls.row}>
                    <Skeleton border={'3px'} width={16} height={16} />
                    <Flex fullWidth direction={'column'} gap={4} align={'start'}>
                        <Skeleton border={'6px'} width={267} height={16} />
                        <Skeleton border={'6px'} width={267} height={12} />
                    </Flex>
                    <Skeleton border={'6px'} width={141} height={16} />
                    <Skeleton border={'6px'} width={95} height={16} />
                    <Skeleton border={'6px'} width={101} height={16} />
                    <Skeleton border={'6px'} width={107} height={16} />
                </div>
                <div className={cls.row}>
                    <Skeleton border={'3px'} width={16} height={16} />
                    <Flex fullWidth direction={'column'} gap={4} align={'start'}>
                        <Skeleton border={'6px'} width={267} height={16} />
                        <Skeleton border={'6px'} width={267} height={12} />
                    </Flex>
                    <Skeleton border={'6px'} width={141} height={16} />
                    <Skeleton border={'6px'} width={95} height={16} />
                    <Skeleton border={'6px'} width={101} height={16} />
                    <Skeleton border={'6px'} width={107} height={16} />
                </div>
                <div className={cls.row}>
                    <Skeleton border={'3px'} width={16} height={16} />
                    <Flex fullWidth direction={'column'} gap={4} align={'start'}>
                        <Skeleton border={'6px'} width={267} height={16} />
                        <Skeleton border={'6px'} width={267} height={12} />
                    </Flex>
                    <Skeleton border={'6px'} width={141} height={16} />
                    <Skeleton border={'6px'} width={95} height={16} />
                    <Skeleton border={'6px'} width={101} height={16} />
                    <Skeleton border={'6px'} width={107} height={16} />
                </div>
            </Flex>
        </Flex>
    );
};
